// ReInit extension for Naja (frontend)
naja.registerExtension({
    initialize: function(naja) {
        naja.addEventListener('start', function() {
            hideAllTooltips();
            closeAllFlashMessages();
        });
        naja.addEventListener('complete', function() {
            initEventsWithReload();
        });
    }
});
